/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampaignLeadsResponseApiModel } from '../../models/campaign-leads-response-api-model';

export interface GetLeadsCsv$Params {
  id: string;
}

export function getLeadsCsv(http: HttpClient, rootUrl: string, params: GetLeadsCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<CampaignLeadsResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, getLeadsCsv.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampaignLeadsResponseApiModel>;
    })
  );
}

getLeadsCsv.PATH = '/marketplace/{id}/csv';
